import { scopeCredential } from "./scopeCredential"

const ChMain         = () => import(/* webpackChunkName: "build-glob" */ './layouts/Main.vue') 
const ChDasboard     = () => import(/* webpackChunkName: "build-glob" */ './pages/Dashboard.vue')
const ChMap          = () => import(/* webpackChunkName: "build-map" */ './pages/Map.vue')
const ChDocument     = () => import(/* webpackChunkName: "build-doc" */ './pages/Document.vue')
const ChEvent        = () => import(/* webpackChunkName: "build-doc" */ './pages/Event.vue')
const ChSlider       = () => import(/* webpackChunkName: "build-glob" */ './components/ui/Slider.vue')
const ChEditCard     = () => import(/* webpackChunkName: "build-glob" */ './components/cards/CardForm.vue')
//const ChViewCard     = () => import(/* webpackChunkName: "build-glob" */ './components/View_card.vue')
//const ChViewAction     = () => import(/* webpackChunkName: "build-glob" */./components/View_card.vueue')

export default {
menu : [
    { 'href': '/dashboard',  'title': 'Tableau de bord', 'icon': 'mdi-view-dashboard', 'role': ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTER_USER', 'AGENT', 'AMP', 'AM', 'ATP1', 'ATP2', 'AT', 'APPRENTI'] },
    { 'href': '/map',        'title': 'Carte', 'icon': 'mdi-map', 'role': ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTER_USER', 'AGENT', 'AMP', 'AM', 'ATP1', 'ATP2', 'AT', 'APPRENTI'] },
    { 'href': '/planning',   'title': 'Planning', 'icon': 'mdi-calendar-multiselect', 'role': ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTER_USER', 'AGENT', 'AMP', 'AM', 'ATP1', 'ATP2', 'AT', 'APPRENTI'] },
    { 'href': '/events',     'title': 'Evenements', 'icon': 'mdi-calendar-text', 'role': ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTER_USER'] },
    //{ 'href': '/documents',  'title': 'Documents', 'icon': 'mdi-briefcase', 'role': ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTER_USER', 'AGENT'] },
    { divider: true },
    { 'header': 'Reporting', 'role': ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTER_USER'] },
    { 'href': '/reports', 'title': 'Export', 'icon': 'mdi-file-chart', 'role': ['ADMIN_USER', 'SUPER_USER', 'INTER_USER'] },
    { divider: true },
    { 'header': 'Paramètres',   'title': 'Paramètres', 'icon': 'mdi-cogs', 'role': ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'PARTE_USER'], items: [
        { 'href': '/projects',  'title': 'Entités', 'icon': 'mdi-folder-multiple', 'role': ['ADMIN_USER'] },
        { 'href': '/themes',     'title': 'Modèles', 'icon': 'mdi-sitemap', 'role': ['ADMIN_USER'] },
        { 'href': '/lists',      'title': 'Listes', 'icon': 'mdi-format-list-bulleted-type', 'role': ['ADMIN_USER', 'SUPER_USER'] },
        //{ 'href': '/block',     'title': 'Blocks', 'icon': 'mdi-drawing-box', 'role': ['ADMIN_USER'] },
        { 'href': '/contacts',  'title': 'Gestion des contacts', 'icon': 'mdi-account-box-multiple', 'role': scopeCredential.contacts.read },
        { 'href': '/equipments', 'title': 'Materiel', 'icon': 'mdi-tools', 'role': ['ADMIN_USER', 'SUPER_USER'] },
        { 'href': '/teams', 'title': 'Équipes', 'icon': 'mdi-account-group', 'role': ['ADMIN_USER', 'SUPER_USER', 'TEAM_LEADER'] },
        { 'href': '/states',    'title': 'Gestion états', 'icon': 'mdi-tag-multiple', 'role': ['ADMIN_USER'] },
        { 'href': '/types',     'title': 'Gestion des types', 'icon': 'mdi-format-list-bulleted-type', 'role': ['ADMIN_USER'] },
        //{ 'href': '/typesaction',     'title': 'Gestion des actions', 'icon': 'mdi-format-list-bulleted-type', 'role': ['SUPER_USER', 'INTER_USER'] },
        { 'href': '/tasktypes',  'scope':'TaskType',  'right': 'update', 'title': 'Type de taches', 'icon': 'mdi-file-tree', 'role': ['SUPER_USER', 'INTER_USER'] },
    ] },
    { divider: true },
    { 'header': 'Systeme', 'role': ['ADMIN_USER', 'SUPER_USER' ] },
    { 'href': '/users', 'title': 'Utilisateurs', 'icon': 'mdi-account', 'role': ['ADMIN_USER', 'SUPER_USER' ] },
//    { 'href': '/importdata',  'title': 'Import / synchro',  'icon': 'mdi-file-upload', 'role': ['ADMIN_USER', 'SUPER_USER'] },
    { 'href': '/jobs',  'title': 'Taches de fond', 'icon': 'mdi-progress-wrench', 'role': ['ADMIN_USER', 'SUPER_USER'] },
],
routes : [
    { name:'login', path: '/login',   component: require('./layouts/Login.vue').default, 
        meta: {
            public: true,  // Allow access to even if not logged in
            onlyWhenLoggedOut: true
        }
    },
    { name:'setpass', path: '/auth/set-password/:token',   component: require('./layouts/Password.vue').default, 
        meta: {
            public: true,  // Allow access to even if not logged in
            onlyWhenLoggedOut: true
        }
    },
    { name:'loginsso', path: '/login/:authcode',   component: require('./layouts/Login.vue').default, 
        meta: {
            public: true,  // Allow access to even if not logged in
            onlyWhenLoggedOut: true
        }
    },
    { name:'logout', path: '/logout',   component: require('./layouts/Logout.vue').default },
    { name:'magiclink', path: '/magiclink/:token', component: require('./layouts/Login.vue').default, 
        meta: {
            public: true,  // Allow access to even if not logged in
            onlyWhenLoggedOut: false
        }
    },
    { name: '404', path: '*', component: require('./layouts/404.vue').default },
    { name: '401', path: '/401', component: require('./layouts/401.vue').default },
    { path: '/', component: ChMain,
        children: [
            { name: 'home', path: '/', redirect: '/dashboard' },
            { name: 'dashboard', path: '/dashboard', 
                components: { default: ChDasboard, modal: ChSlider },
                children: [
                    { name: 'dash-slide-prev', path: 'sheet/:cad_uid', meta: { component: 'cardView' }, components: { content: ChEditCard } },
                    { name: 'dash-slide-edit', path: 'sheet/:cad_uid/layer/:lra_id/type/:typ_id', components: { content: ChEditCard } },
                  //{ name: 'dash_slide_view', path: 'sheet/:cad_uid/action/:act_id', components: { content: ChViewAction } }
                ]
            },
            { name: 'map', path: '/map', 
                components: { default: ChMap, modal: ChSlider },
                children: [
                    { name: 'map-slide-loca', path: 'center/:latlng' },
                    { name: 'map-slide-prev', path: 'sheet/:cad_uid', meta: { component: 'cardView' }, components: { content: ChEditCard } },
                    { name: 'map-slide-edit', path: 'sheet/:cad_uid/layer/:lra_id/type/:typ_id', components: { content: ChEditCard } },
                  //{ name: 'map_slide_view', path: 'sheet/:cad_uid/action/:act_id', components: { content: ChViewAction } }
                ]
            },
            { name: 'event', path: '/events', 
                components: { default: ChEvent, modal: ChSlider },
                children: [
                    { name: 'eve-slide_prev', path: 'sheet/:cad_uid', meta: { component: 'cardView' }, components: { content: ChEditCard } },
                  //{ name: 'eve_slide_edit', path: 'sheet/:cad_uid/modifier', components: { content: ChViewAction } },
                  //{ name: 'eve_slide_view', path: 'sheet/:cad_uid/action/:act_id', components: { content: ChViewAction } }
                ]
            },
            { name: 'document', path: '/documents', 
                components: { default: ChDocument, modal: ChSlider },
                children: [
                    { name: 'doc-slide_prev', path: 'sheet/:cad_uid', meta: { component: 'cardView' }, components: { content: ChEditCard } },
                  //{ name: 'doc_slide_edit', path: 'sheet/:cad_uid/modifier', components: { content: ChViewAction } },
                  //{ name: 'doc_slide_view', path: 'sheet/:cad_uid/action/:act_id', components: { content: ChViewAction } }
                ]
            },
            { name: 'planning',        path: '/planning', component: require('./pages/Planning.vue').default },
            { name: 'report',          path: '/reports', component: require('./pages/Report.vue').default },
            
            { name: 'projects',        path: '/projects',               component: require('./pages/Project.vue').default },
            { name: 'projects-view',   path: '/projects/:pro_id/view',  component: require('./components/projects/ProjectView.vue').default },
            { name: 'projects-edit',   path: '/projects/:pro_id/edit',  component: require('./components/projects/ProjectForm.vue').default },
            { name: 'themes-list',          path: '/themes',                 component: require('./pages/Theme.vue').default },
            { name: 'themes-edit',     path: '/themes/:tem_id',                 component: require('./pages/Theme.vue').default },
            { name: 'lists-list',      path: '/lists',                 component: require('./pages/List.vue').default },
            { name: 'lists-edit',      path: '/lists/:lst_id',         component: require('./pages/List.vue').default },
            { name: 'objecttype-edit', path: '/themes/:tem_id/objecttype/:obt_id', component: require('./components/themes/ObjecttypeForm.vue').default },
            { name: 'equipments-list', path: '/equipments',             component: require('./pages/Equipment.vue').default },
            { name: 'equipments-edit', path: '/equipments/:equ_id',     component: require('./pages/Equipment.vue').default },

            { name: 'teams-list',      path: '/teams',                  component: require('./pages/Teams.vue').default },
            { name: 'teams-edit',      path: '/teams/:id',              component: require('./pages/Teams.vue').default },

            { name: 'states-list',     path: '/states',                  component: require('./pages/States.vue').default },
            { name: 'states-edit',     path: '/states/:sta_id',          component: require('./components/states/StatesForm.vue').default },
            { name: 'types',           path: '/types',                   component: require('./pages/Types.vue').default },
            { name: 'types-edit',      path: '/types/:typ_id',           component: require('./components/types/TypesForm.vue').default },
            { name: 'typesaction',     path: '/typesaction',             component: require('./pages/Types.vue').default },
            { name: 'typesaction-edit',path: '/typesaction/:typ_id',     component: require('./components/types/TypesForm.vue').default },
            { name: 'tasktypes-list',  path: '/tasktypes',         component: require('./pages/TaskTypes.vue').default },
            { name: 'tasktypes-edit',  path: '/tasktypes/:tty_id', component: require('./components/tasktypes/TaskTypesForm.vue').default },
            { name: 'contacts-list',   path: '/contacts',          component: require('./pages/Contacts.vue').default },
            { name: 'contacts-edit',   path: '/contacts/:ctt_id',  component: require('./pages/Contacts.vue').default },
            
            { name: 'users',         path: '/users',             component: require('./pages/Users.vue').default },
            { name: 'users-edit',    path: '/users/:id',         component: require('./pages/Users.vue').default },
            
            //{ name: 'importdata',   path: '/importdata', component: require('./pages/ImportData.vue').default },
            { name: 'jobs',         path: '/jobs', component: require('./pages/BackgroundJobs.vue').default },
            { name: 'forbidden',    path: '/forbidden', component: require('./layouts/403.vue').default },
            
        ]
    }
]


}